import { render, staticRenderFns } from "./SttrExL.vue?vue&type=template&id=4b8d0660"
import script from "./SttrExL.vue?vue&type=script&lang=js"
export * from "./SttrExL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports